import React from 'react';
import { Card, Alert, Badge } from 'react-bootstrap';
import { FaClock } from "react-icons/fa";
import StatisticsOverview from './StatisticsOverview';
import ChartsContainer from './ChartsContainer';
import DataTable from './DataTable';
import { useChartData } from './hooks/useChartData';
import { formatDateRange, getTimeRangeDisplayText } from './utils/formatters';

const DashboardBody = ({ 
  healthMetrics, 
  timeRangeType, 
  timeRange, 
  userInfo,
  handleTimeRangeChange,
  customDateRange,
  setCustomDateRange,
  handleCustomDateApply 
}) => {
  const { chartData, hasData, stats } = useChartData(healthMetrics, timeRangeType);
  return (
    <Card.Body>
      {/* Aggregation Info Alert - Simplified */}
      <Alert variant="info" className="mt-3">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <strong>Health Data Overview</strong>
            <br />
            <small className="text-muted"> 
              Time Range: {formatDateRange(timeRange.fromDate, timeRange.toDate)}
            </small>
          </div>
          <div className="d-flex flex-column align-items-end">
            <Badge bg="info" className="text-nowrap mb-1">
              {timeRangeType === 'today' ? '2-hour Aggregation' : 'Daily Aggregation'}
            </Badge>
            <Badge bg="success" className="text-nowrap">
              {chartData.filter(item => !item.isEmptyData).length} Data Points
            </Badge>
          </div>
        </div>
      </Alert>

      <StatisticsOverview stats={stats} timeRangeType={timeRangeType} />
      
      {/* Charts Container with time range selector */}
      <ChartsContainer 
        chartData={chartData} 
        timeRangeType={timeRangeType}
        handleTimeRangeChange={handleTimeRangeChange}
        customDateRange={customDateRange}
        setCustomDateRange={setCustomDateRange}
        handleCustomDateApply={handleCustomDateApply}
        getTimeRangeDisplayText={getTimeRangeDisplayText}
      />

      <DataTable chartData={chartData} timeRangeType={timeRangeType} />
    </Card.Body>
  );
};

export default DashboardBody;